import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { MetaMaskContextProvider } from './hooks/useMetamask';
import { ThirdwebProvider, metamaskWallet } from "@thirdweb-dev/react";
import { ThirdwebProvider as ThirdwebProviderV5 } from "thirdweb/react"
import { Sepolia } from "@thirdweb-dev/chains";
import { ThirdwebStorage, StorageDownloader, IpfsUploader } from "@thirdweb-dev/storage";
import { APIConstants } from './constants/api';
import { MSALConstants } from './constants/msal';
import { THIRDWEBConstants } from './constants/thirdweb';
import { ProjectProvider } from './context/Project';
import { UserProvider } from './context/User';
import { PixelProvider } from './context/Pixel';

//Azure Insights imports
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const pca = new PublicClientApplication(MSALConstants.AUTH.CONFIGURATION);

const gatewayUrls = THIRDWEBConstants.GATEWAY.URLS;
const downloader = new StorageDownloader();
const uploader = new IpfsUploader();
const storage = new ThirdwebStorage({ uploader, downloader, gatewayUrls });
const ethereumRpcUrl = APIConstants.URLS.RPC.ETHEREUM;

//Implement Azure Insights
const appinsightsConnectionString = process.env.REACT_APP_BUILDE_APPINSIGHTS_CONNECTIONSTRING;
//console.log('Application Insights Connection String:', appinsightsConnectionString);
if (appinsightsConnectionString) {
  try {
    console.log('Start appinsight instrumentation');
    const browserHistory = createBrowserHistory({ basename: '' });
    var reactPlugin = new ReactPlugin();
    // *** Add the Click Analytics plug-in. ***
    /* var clickPluginInstance = new ClickAnalyticsPlugin();
      var clickPluginConfig = {
        autoCapture: true
    }; */
    var appInsights = new ApplicationInsights({
        config: {
            connectionString: appinsightsConnectionString,
            // *** If you're adding the Click Analytics plug-in, delete the next line. ***
            extensions: [reactPlugin],
        // *** Add the Click Analytics plug-in. ***
        // extensions: [reactPlugin, clickPluginInstance],
            extensionConfig: {
              [reactPlugin.identifier]: { history: browserHistory }
          // *** Add the Click Analytics plug-in. ***
          // [clickPluginInstance.identifier]: clickPluginConfig
            }
        }
    });
    appInsights.loadAppInsights();
    console.log('Finish appinsight instrumentation');
  } catch (error) {
    console.log('Error starting appinsight instrumentation:', error);
  }
}
// End Azure Insights implementation

root.render(
  <BrowserRouter basename={baseUrl}>
    <MsalProvider instance={pca}>
      <MetaMaskContextProvider>
        <ThirdwebProvider
          supportedWallets={[metamaskWallet()]}
          storageInterface={storage}
          activeChain={{
            ...Sepolia,
            rpc: [ethereumRpcUrl]
          }}
        >
          <ThirdwebProviderV5>
            <PixelProvider>
              <UserProvider>
                <ProjectProvider>
                  <App />
                </ProjectProvider>
              </UserProvider>
            </PixelProvider>
          </ThirdwebProviderV5>
        </ThirdwebProvider>
      </MetaMaskContextProvider>
    </MsalProvider>
  </BrowserRouter>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
